import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'interactive' | 'success' | 'error';
}

export function Card({
  className,
  variant = 'default',
  children,
  ...props
}: CardProps) {
  return (
    <div
      className={cn(
        'rounded-lg p-5',
        'bg-white dark:bg-stone-900',
        'border border-stone-200 dark:border-stone-800',
        variant === 'interactive' && [
          'cursor-pointer transition-all duration-150',
          'hover:border-primary-400 dark:hover:border-primary-600',
          'hover:shadow-sm',
        ],
        variant === 'success' && [
          'border-lime-600 dark:border-lime-700',
          'bg-lime-50 dark:bg-lime-950/30',
        ],
        variant === 'error' && [
          'border-red-600 dark:border-red-700',
          'bg-red-50 dark:bg-red-950/30',
        ],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
